import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-2.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')